var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topTitle"},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("遵义医科大学附属医院")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }